import * as React from "react";
import * as cn from "classnames";
import { Link } from "react-router-dom";
import {History} from "history";
import LocationDescriptor = History.LocationDescriptor;

import styles = require("./style.less");

interface ListInternalLinkProps extends React.HTMLProps<HTMLElement> {
    size?: number;
    to: LocationDescriptor;
    className?: string;
    onClick?: () => void;
}

const ListInternalLink: React.SFC<ListInternalLinkProps> = (props: ListInternalLinkProps) => {
    const onClick = (e: any) => {
        if (props.onClick) {
            props.onClick();
        }
        e.stopPropagation();
    };

    const style: any = { fontSize: props.size + "rem" };

    return <Link className={cn(styles.listInternalLink, props.className)}
        style={style}
        to={props.to}
        onClick={onClick}>
        {props.children}
    </Link>;
};

export default ListInternalLink;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/InternalLink/ListInternalLink.tsx